module.exports = __webpack_public_path__ + "static/media/news49.221e70ec.jpg";